import { ApplicationConfig, importProvidersFrom, APP_INITIALIZER, LOCALE_ID } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbModule, NgbDateAdapter, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader, provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { provideLottieOptions } from 'ngx-lottie';
import player from 'lottie-web';
import { appRoutes } from './app/app-routes';
import { configFactory } from './app/app.initializers';
import { ConfigService } from './app/services/config.service';
import { HttpconfigInterceptor } from './app/interceptors/http-config.interceptor';
import { AuthInterceptor } from './app/interceptors/auth-interceptor.service';
import { CustomDateAdapter, CustomDateParserFormatter } from './app/shared/date-adapter';
import { APP_CONFIG } from '@mnc/shared-library';
import { environment } from './environments/environment';

export function playerFactory() {
  return player;
}

registerLocaleData(localeEs, 'es');

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(
      NgbModule,
      ReactiveFormsModule,
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useClass: TranslateHttpLoader,
        },
        defaultLanguage: 'es'
      })
    ),
    ...provideTranslateHttpLoader({ prefix: 'assets/i18n/', suffix: '.json' }),
    provideRouter(appRoutes),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    provideLottieOptions({ player: playerFactory }),
    { provide: LOCALE_ID, useValue: 'es' },
    { provide: APP_INITIALIZER, useFactory: configFactory, deps: [ConfigService], multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpconfigInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: NgbDateAdapter, useClass: CustomDateAdapter },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
    { provide: APP_CONFIG, useValue: environment },
  ]
};